import { render, staticRenderFns } from "./EdicionProveedor.vue?vue&type=template&id=360662ce&"
import script from "./EdicionProveedor.vue?vue&type=script&lang=js&"
export * from "./EdicionProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports